
namespace SP {
    export interface BarcodeTemplate {
        id: string;
        name: string;
    }
}
